var map = {
	"./cocar_100A.png": "4af7",
	"./custom.png": "a04a",
	"./dweekiy_300A.png": "1648",
	"./hella_1000A.png": "b803",
	"./trennschalter_1_2_both_off.png": "dfb1",
	"./wakauto_180A.png": "aa65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05b3";